import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
// import { createTheme } from "@mui/material/styles";
import { AppSingleton, _musicList } from "../services/user_config";
import ReactPlayer from "react-player";
import ReactPageScroller, { SectionContainer } from "react-page-scroller";
import { Box, Grid, Slide, Typography } from "@mui/material";
import "./music-section.css";

const MediaSection = () => {
  const location = useLocation();
  const { author_name, url, uuid, title } = location.state;

  // const [musicList, setMusicList] = useState(_musicList);
  // const [currentMusic, setCurrentMusic] = useState(musicList[0]);
  const theme = new AppSingleton().theme;

  return (
    <>
      <Slide
        direction="left"
        in={true}
        mountOnEnter
        unmountOnExit
        easing={{
          enter: theme.transitions.easing.easeOut,
          exit: theme.transitions.easing.easeIn,
        }}
        timeout={1000}
      >
        <Box>
          <Box sx={{ p: 4 }}>
            <Typography variant="h4">{title}</Typography>
            <Typography variant="h5" sx={{ pt: 2 }}>
              {author_name}
            </Typography>
          </Box>

          <Grid container spacing={4}>
            <Grid key="player-window" item xs={12} loading="lazy">
              <div className="wrapper">
                <ReactPlayer
                  className="player"
                  width="100%"
                  height="100%"
                  key={uuid}
                  url={url}
                  controls
                  playing
                  // muted
                  volume={1.0}
                  config={{
                    youtube: {
                      playerVars: { showinfo: 0 },
                      onUnstarted: (v) => {
                        // console.log("on unstarted");
                        console.log(v);
                      },
                      embedOptions: {
                        events: {
                          onReady: (evt) => {
                            // console.log(`Ready: ${title}`);
                            console.log(evt);
                            evt.target?.playVideo();
                          },
                          onStateChange: (evt) => {
                            // console.log(`State Change: ${music.name}`);
                            // console.log(evt);
                          },
                        },
                      },
                    },
                  }}
                />
              </div>
            </Grid>
          </Grid>
        </Box>
      </Slide>
    </>
  );
};

export { MediaSection };
